import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

// Auth / public pages
import Login from "./components/pages/Login";
import Register from "./components/pages/Register";
import ForgotPassword from "./components/pages/ForgotPassword";
import ChangePassword from "./components/pages/ChangePassword";
import VerifyPage from "./components/pages/Verify";
import LandingPage from "./components/pages/landingPage";
import PrivacyPolicy from "./components/pages/Privacy_Policy";
import TermsOfUse from "./components/pages/TermsOfUse";
import NotFound from "./components/pages/NotFound";
import InstallPage from "./components/pages/install/InstallPage";

// Authenticated pages
import Apps from "./components/pages/apps/Applist";
import AddApp from "./components/pages/apps/AddApp";
import EditApp from "./components/pages/apps/EditApp";
import Builds from "./components/pages/builds/BuildList";
import AddBuild from "./components/pages/builds/AddBuild";
import BuildDetails from "./components/pages/builds/BuildDetails";
import Users from "./components/pages/user/Users";
import AddUser from "./components/pages/user/AddUser";
import UserDetails from "./components/pages/user/UserDetails";
import UserPassword from "./components/pages/UserPassword";
import Organizations from "./components/pages/Organization/Organizations";
import OrganizationDetails from "./components/pages/Organization/OrganizationDetails";
import CreateOrganization from "./components/pages/Organization/CreateOrganization";

// Routing guards + app chrome
import AuthRoute from "./AuthRoute";
import PrivateRouter from "./PrivateRouter";
import Toast from "./components/LoadingError/Toast";

import './App.css';
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <>
      <Toast/>
      <Router>
        <Switch>
          {/* Public / pre-login */}
          <AuthRoute path="/landing" component={LandingPage} />
          <AuthRoute path="/login" component={Login} />
          <AuthRoute path="/register" component={Register} />
          <AuthRoute path="/Verify/:token" component={VerifyPage} />
          <AuthRoute path="/forgot-password" component={ForgotPassword} />
          <AuthRoute path="/change-password/:token" component={ChangePassword} />
          <Route path="/terms-of-use" component={TermsOfUse} />
          <Route path="/privacy-policy" component={PrivacyPolicy} />
          {/* Public install landing page — Diawi-style. Intentionally
              NOT wrapped in AuthRoute/PrivateRouter; anyone with the
              link can install a Public build. Build id is the bearer
              capability; backend enforces visibility. */}
          <Route path="/install/:appId/:buildId" component={InstallPage} />

          {/* Authenticated — apps / builds */}
          <PrivateRouter path="/apps" component={Apps} />
          <PrivateRouter path="/app/add" component={AddApp} />
          <PrivateRouter path="/app/request" component={AddApp} />
          <PrivateRouter path="/app/edit/:id" component={EditApp} />
          <PrivateRouter path="/app/:id/builds" component={Builds} />
          <PrivateRouter path="/app/:id/build/add" component={AddBuild} />
          <PrivateRouter path="/app/:id/build/:buildId/view" component={BuildDetails} />

          {/* Authenticated — organizations */}
          <PrivateRouter path="/organizations" component={Organizations} />
          <PrivateRouter path="/organization/details/:id" component={OrganizationDetails} />
          <PrivateRouter path="/organization/create" component={CreateOrganization} />
          <PrivateRouter path="/organization/:organizationId/app/:id/builds" component={Builds} />
          <PrivateRouter path="/organization/:organizationId/app/:id/build/:buildId/view" component={BuildDetails} />

          {/* Authenticated — users + profile */}
          <PrivateRouter path="/users" component={Users} />
          <PrivateRouter path="/user/add" component={AddUser} />
          <PrivateRouter path="/user-password" component={UserPassword} />
          <PrivateRouter path="/user-details" component={UserDetails} />
          <PrivateRouter path="/user/edit/:id" component={AddUser} />

          <PrivateRouter path="*" component={NotFound} />
        </Switch>
      </Router>
    </>
  );
}

export default App;
